"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceTypeLabelKeyMap = exports.FoodOrderServiceType = void 0;
exports.useServiceTypeLabel = useServiceTypeLabel;
exports.useServiceTypeLabelNode = useServiceTypeLabelNode;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _LocaleProvider = require("../LocaleProvider");
var _food = _interopRequireDefault(require("../../assets/images/food.svg"));
var _spxInstant = _interopRequireDefault(require("../../assets/images/spx-instant.svg"));
var _spxInstantShopee = _interopRequireDefault(require("../../assets/images/spx-instant-shopee.svg"));
var _spxSameday = _interopRequireDefault(require("../../assets/images/spx-sameday.svg"));
var _ServiceTypeLabelKeyM;
var FoodOrderServiceType;
exports.FoodOrderServiceType = FoodOrderServiceType;
(function (FoodOrderServiceType) {
  FoodOrderServiceType[FoodOrderServiceType["Food"] = 1] = "Food";
  FoodOrderServiceType[FoodOrderServiceType["SPXInstantShopee"] = 2] = "SPXInstantShopee";
  FoodOrderServiceType[FoodOrderServiceType["SPXInstant"] = 3] = "SPXInstant";
  FoodOrderServiceType[FoodOrderServiceType["SPXSameDayShopee"] = 4] = "SPXSameDayShopee";
})(FoodOrderServiceType || (exports.FoodOrderServiceType = FoodOrderServiceType = {}));
var ServiceTypeLabelKeyMap = (_ServiceTypeLabelKeyM = {}, (0, _defineProperty2.default)(_ServiceTypeLabelKeyM, FoodOrderServiceType.Food, 'Food'), (0, _defineProperty2.default)(_ServiceTypeLabelKeyM, FoodOrderServiceType.SPXInstant, 'SPX Instant'), (0, _defineProperty2.default)(_ServiceTypeLabelKeyM, FoodOrderServiceType.SPXInstantShopee, 'SPX Instant (Shopee)'), (0, _defineProperty2.default)(_ServiceTypeLabelKeyM, FoodOrderServiceType.SPXSameDayShopee, 'SPX Sameday (Shopee)'), _ServiceTypeLabelKeyM);
exports.ServiceTypeLabelKeyMap = ServiceTypeLabelKeyMap;
function useServiceTypeLabel(serviceType) {
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  return [trans(ServiceTypeLabelKeyMap[serviceType])];
}
function useServiceTypeLabelNode(serviceType) {
  var _useServiceTypeLabel = useServiceTypeLabel(serviceType),
    _useServiceTypeLabel2 = (0, _slicedToArray2.default)(_useServiceTypeLabel, 1),
    label = _useServiceTypeLabel2[0];
  var renderLabel = function renderLabel(label) {
    switch (serviceType) {
      case FoodOrderServiceType.Food:
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
          src: _food.default
        }), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            color: 'rgba(246, 145, 19, 1)'
          }
        }, label));
      case FoodOrderServiceType.SPXInstant:
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
          src: _spxInstant.default
        }), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            color: 'rgba(38, 170, 153, 1)'
          }
        }, label));
      case FoodOrderServiceType.SPXInstantShopee:
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
          src: _spxInstantShopee.default
        }), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            color: 'rgba(0, 70, 171, 1)'
          }
        }, label));
      case FoodOrderServiceType.SPXSameDayShopee:
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
          src: _spxSameday.default
        }), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            color: 'rgba(238, 44, 74, 1)'
          }
        }, label));
    }
  };
  return [renderLabel(label)];
}